module.exports = require("./es-MX.js");